<template>
    <div class="newsAndEvents">
        <page-cover
            v-if="newsEventPage.PageCover"
            :img="newsEventPage.PageCover.Image?.url ?? ''"
            :title="newsEventPage.PageCover.Title"
            :sub-title="newsEventPage.PageCover.Subtitle"
        />
        <section>
            <div class="px-4 py-8 md:px-12 md:py-12">
                <div
                    class="flex md:justify-end gap-4 mb-4 md:mb-12 overflow-x-auto md:overflow-x-hidden"
                >
                    <button
                        v-for="(c, index) in categories"
                        :key="index"
                        class="btn btn-bordered mb-4"
                        :class="{ 'btn-active': activeFilter === c }"
                        @click="onSelect(c)"
                    >
                        {{ c }}
                    </button>
                </div>
                <masonry-layout :data-items="filteredData" />
            </div>
        </section>
    </div>
</template>

<script setup>
const config = useRuntimeConfig();
useHead({
    title: 'News & Events',
});
const { data: newsEventPage } = await useFetch(
    config.public.baseURl + '/news-and-events-page'
);
const { data: newsEventsData } = await useFetch(
    config.public.baseURl + `/news-and-events?_sort=Type,createdAt:DESC`
);
const categories = ['All', 'Events', 'News'];

const filteredData = ref(null);
const activeFilter = ref('');
function onSelect(category) {
    activeFilter.value = category;
    if (category && category !== 'All') {
        filteredData.value = newsEventsData.value.filter(
            (item) => item.Type === category
        );
    } else {
        filteredData.value = newsEventsData.value;
    }
}

onSelect('All');
</script>

<style lang="scss" scoped>
.newsAndEvents {
}
</style>
